import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useBreakpoint from './useBreakpoint';
import CustomTableRow from './components/CustomTableRow';
import { replaceUnderscoreAndCamelCaseToString } from './MyEvaluations';
import Pagination from './components/Pagination';

export default function AllEvaluations() {
  const navigate = useNavigate();
  const [size] = useBreakpoint();


  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [allCourses, setAllCourses] = React.useState([]);
  const [courseCodeOn, setCourseCodeOn] = React.useState(false);
  const [courseTitle, setCourseTitle] = React.useState("");
  const [courseCode, setCourseCode] = React.useState("");

  React.useEffect(() => {


    axios.get("http://ascola-dev01.it.auth.gr/api/courses", {
        params: {
            course_title: courseTitle, course_code: courseCode, page: page + 1, limit: rowsPerPage
        }, headers: { Authorization: "Bearer " + localStorage.getItem('access_token')} })
    .then((response) => {
        console.log(response); setAllCourses(response.data);
    });
}, [rowsPerPage, page, courseTitle, courseCode]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChange = (e) => {
    
    if (e.target.type === "switch") {
        setCourseCodeOn(!courseCodeOn);
    }
    else {
        courseCodeOn ? setCourseCode(e.target.value) : setCourseTitle(e.target.value);
    }
}

  return (<>
    {(size !== "xs" && size !== "sm" && size !== "md") && (<>
    <div className="all-evaluations-main-container rounded-3 mx-auto d-flex flex-column align-items-center position-relative" >
        <div className="title mb-4">
            <h1 className="register-text" style={{fontSize: 40, marginBottom: 25, marginTop: 70}}>All evaluations</h1>
            <div style={{marginBottom: 40, fontSize: 16, textAlign: "left", marginTop: 10}}>Here you can browse courses evaluations. Search by entering the exact full title of the course or the course code,<br/> 
            click on the class you’re interested in and access feedback submitted by previous exchange students.
            </div>
            <div className='rounded-3 mx-auto flex-column align-items-center' style={{marginBottom: 20, marginTop: 40, width: "80%"}} onChange={(e) => handleChange(e)}>
              <Form.Group className="mb-3" controlId="formRoleName">
                {/* <Form.Label className="form-label">What is your age? *</Form.Label> */}
                <Form.Control
                    placeholder={courseCodeOn ? "course code" : "Enter exact full course title or  use the switch to search by course code"}
                    // value={summary}
                    required
                    id="age"
                    // value={firstStep?.age}
                    // onChange={(e) => setSummary(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please provide a description.
                </Form.Control.Feedback>
            </Form.Group></div>
            <div className='rounded-3 mx-auto flex-column align-items-center' style={{marginBottom: 40, width: "30%", fontSize: 15}}>
            <Form.Group controlId="formAuthorizations">
                <Form.Check // prettier-ignore
                  type="switch"
                  id="custom-switch"
                  label="Search by course code"
                  checked={courseCodeOn}
                  onChange={() => setCourseCodeOn(!courseCodeOn)}
                />
                </Form.Group>
            </div>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
                <TableCell>COURSE TITLE</TableCell>
                <TableCell align="right">COURSE CODE</TableCell>
                <TableCell align="right">ACADEMIC TERM</TableCell>
                <TableCell align="right">ECTS</TableCell>
                <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {allCourses?.courses?.map((row) => (
                <TableRow
                key={row.name}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                onClick={() => navigate("/all-evaluations/" + row?.course_id)}
                style={{cursor: "pointer"}}
                hover
                >
                <TableCell component="th" scope="row">
                    {row?.course_title}
                </TableCell>
                <TableCell align="right">{row?.course_code}</TableCell>
                <TableCell align="right">{row?.academic_term}</TableCell>
                <TableCell align="right">{row?.ects}</TableCell>
                <TableCell align="right">
                </TableCell>
                </TableRow> 
            )
                
            )}

          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15, 20]}
        component="div"
        count={allCourses?.total_count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper></div></div></>)}
    {(size === "xs" || size === "sm" || size === "md") && ( <>
      <div className="first-step-main-container rounded-3 mx-auto d-flex flex-column align-items-center position-relative" style={{width: "90%"}}>
    <div className="title mb-4">
    <h1 className="register-text" style={{fontSize: 40, marginBottom: 25, marginTop: 40}}>All evaluations</h1>
            <div style={{marginBottom: 40, fontSize: 16, textAlign: "left", marginTop: 10}}>Here you can browse courses evaluations. Search by entering the exact full title of the course or the course code,<br/> 
            click on the class you’re interested in and access feedback submitted by previous exchange students.
            </div>
            <div className='rounded-3 mx-auto flex-column align-items-center' style={{marginBottom: 20, marginTop: 40, width: "100%"}} onChange={(e) => handleChange(e)}>
              <Form.Group className="mb-3" controlId="formRoleName">
                {/* <Form.Label className="form-label">What is your age? *</Form.Label> */}
                <Form.Control
                    placeholder={courseCodeOn ? "course code" : "Enter exact full course title or  use the switch to search by course code"}
                    // value={summary}
                    required
                    id="age"
                    // value={firstStep?.age}
                    // onChange={(e) => setSummary(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please provide a description.
                </Form.Control.Feedback>
            </Form.Group></div>
            <div className='rounded-3 mx-auto flex-column align-items-center' style={{marginBottom: 40, width: "70%", fontSize: 15}}>
            <Form.Group controlId="formAuthorizations">
                <Form.Check // prettier-ignore
                  type="switch"
                  id="custom-switch"
                  label="Search by course code"
                  checked={courseCodeOn}
                  onChange={() => setCourseCodeOn(!courseCodeOn)}
                />
                </Form.Group>
            </div>
        {allCourses?.courses?.map((row, index) => {
                  return (
                    <CustomTableRow
                      key={"row-id-" + (row?.course_id || index)}
                      row={row}
                      labels={allCourses?.courses?.length ? ["course_title", "course_code", "academic_term", "ects"] : []}
                      fieldToHeader={replaceUnderscoreAndCamelCaseToString}
                    //   columnsPerFieldMap={columnsPerFieldMap}
                    //   rowClassName={rowClassName}
                    //   className={`${
                    //     onClickHandlers.length > index
                    //       ? "table-row-with-on-click-handler"
                    //       : ""
                    //   }`}
                      onClickHandler={
                        () => navigate("/all-evaluations/" + row?.course_id)
                      }
                    //   onMouseDown={
                    //     onMouseDownHandlers?.length > index
                    //       ? onMouseDownHandlers[index]
                    //       : undefined
                    //   }
                    >
                    </CustomTableRow>
                  );
                })}
                {(
                  <div className="d-flex justify-content-center">
                    <Pagination
                      total={allCourses?.total_count}
                      page={page}
                      pageLimit={rowsPerPage}
                      setPage={(p) => setPage(p)}
                    />
                  </div>
                )}
    </div></div>
    </>)}
    
    </>
  );
}